export enum ReadTypes {
  All = 0,
  Read = 1,
  Unread = 2,
}

export function getReadTypeName(value: ReadTypes): string {
  switch (value) {
    case ReadTypes.All: return 'すべて';
    case ReadTypes.Read: return '既読';
    case ReadTypes.Unread: return '未読';
  }
}
